import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ExpandableSection } from '../ExpandableSection';
import { VeiculosDetails } from './VeiculosDetails';
export var ExpandableSectionVeiculos = function (_a) {
    var veiculos = _a.veiculos;
    return (_jsx(ExpandableSection, { title: "Dados dos Ve\u00EDculos", children: veiculos === null || veiculos === void 0 ? void 0 : veiculos.map(function (veiculo, index) { return (_jsx(VeiculosDetails, { veiculo: veiculo, index: index + 1 }, veiculo.id)); }) }));
};
